(function () {
    'use strict';

    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            settings: {
                "title": "Settings",
                "tabAccount": "Account",
                "tabAccountHR": "User profile",
                "tabNotifications": "Notifications",
                "tabSecurity": "Security",
                "contactInfo": "Your contact information",
                "contactInfoBtn": "Edit",
                "contactInfoConfirmBtn": "Confirm",
                "contactInfoCancelBtn": "Cancel",
                "contactInfoName": "Name and surname",
                "contactInfoAddress": "Address",
                "contactInfoPhone": "Phone",
                "blocades": "Blocades",
                "blockLogin": "Block logins to web banking",
                "blockMobile": "Block logins to mobile banking",
                "blockPayment": "Block payment card",
                "accountSettings": "Accounts settings",
                "defaultAccount": "Default account",
                "statementsDelivery": "Statements delivery",
                "statementsDeliveryPaper": "Home delivery of paper statements",
                "statementsDeliveryElectronic": "Electronic statements in web banking",
                "messagesSettings": "Message settings",
                "messagesSettingsLabel": "Select if you want to recieve all messages from bank also to your email account",
                "securitySettings": "Security settings",
                "transactionsConfirmation": "Transactions confirmation",
                "transactionsConfirmationSMS": "Receive password via SMS on mobile phone number",
                "transactionsConfirmationOTP": "Password from OTP password generator",
                "transactionsConfirmationText": "More information on transaction confirmation can be found on ",
                "transactionsConfirmationLink": "our website.",
                "notificationSettings": "Notification settings",
                "gsm": "Mobile phone number",
                "oldPass": "Old password",
                "newPass": "New password",
                "againPass": "Again new password",
                "noMatch": "No match",
                "change": "Change",
                "street": "Street",
                "houseNumber": "House number",
                "postalCode": "Postal code",
                "city": "City",
                "streetRequiredErrMsg": "Street is required!",
                "houseNumRequiredErrMsg": "House number is required!",
                "cityOrPostalCodeRequiredErrMsg": "City or postal code is required!",
                "emailRequiredErroMsg": "e-mail is required!",
                "invalidEmailRequiredErroMsg": "e-mail is not valid!",
                "orderSoftToken": "Order soft token",
                "setBlockade": "Set blockade",
                "passwordFromSMS": "Receive password via SMS on mobile phone",
                "passwordFromOTP": "Password from OTP password generator",
                "additionalTransactionsInfo": "Select additional transaction confirmation",
                "blockadeOfAddikoEbank": "Blockade of Addiko EBank/Addiko Mobile operations",
                "blockadeOfAddikoEBankText": "You can disable the use of the Addiko EBank/Addiko Mobile for a fixed or indefinite period of time.",
                "userBasedNotifications": "User based notifications",
                "accountBasedNotifications": "Account based notifications",
                "forAccount": "For account",
                "ebankLoginNotice": "Addiko EBank login notice",
                "maturedTermDeposit": "Matured term deposit notice (5 days before maturity)",
                "maturedSavings": "Matured saving notice (5 days before maturity)",
                "periodicNotice": "Notice of available balance on account",
                "accountBalanceUnder": "Notice of account balance under the specified amount",
                "accountBalanceAbove": "Notice of account balance above the specified amount",
                "accountInflow": "Account inflow notice",
                "accountOutflow": "Account outflow notice",
                "ebankSuccessfull": "Addiko EBank successful payment notice",
                "ebankUnSuccessfull": "Addiko EBank unsuccessful payment notice",
                "rejectedSEPA": "Rejected SEPA Direct Debit notice",
                "newInvoiceNotice": "New e-invoice notice",
                "enabled": "Enabled",
                "disabled": "Disabled",
                "mothersLastName": "Mothers last name",
                "email": "Email",
                "lengthError":"Password should contain at least 8 characters in the field New password !",
                "lengthOldError":"Password should contain at least 6 characters in the field Old password !",
                "enableMail": "Enable Email",
                "enableSms": "Enable SMS",
                "disableSms": "Disable SMS",
                "disableMail": "Disable Email",
                "successOrder": "Naročilo je bilo uspešno oddano.",
                "notificationsNote": "You can subscribe to receive the selected notifications and message alerts via the Addiko EBank. You can receive the messages to your mobile phone or your e-mail address. Transmission of SMS messages is a payable service of the telephone provider Telekom Slovenije d.d. Fee for the transmission of SMS messages and alerts is charged accordingly by",
                "notificationsNoteLink": "Addiko Bank d.d. pricelist.",
                "changeEMail": "Set E-Mail address",
                "emailAddress": "E-Mail address",
                "noNumber": "Addiko Bank d.d. does not have your mobile phone number in database. In order to change your mobile phone number, you have to visit the branch office.",
                smsModal: {
                  "user": "User",
                  "forAccount": "For account",
                  "orderDesc": "I want to order",
                  "email": "Email address",
                  "orderNoticeStart": "By entering the data, i agree to receive ordered notices.",
                  "orderNoticeStop": "By entering the data, i agree to stop receiving ordered notices.",
                  "orderSmsStart1": "By entering the data, i agree to receive notices. I declare that i have read and fully agree with the ",
                  "orderSmsStartLink": "General terms and Conditions ",
                  "orderSmsStart2": "for managing transaction account and provision of payment services.",
                  "next":"Next",
                  "cancel":"Cancel",
                  "back":"Back",
                  "gsm":"Mobile phone number",
                  "receivingSmsStart":"Receiving of notifications via sms",
                  "receivingEmailStart":"Receiving of notifications via email",
                  "receivingSmsStop":"Disable automated sms notices",
                  "receivingEmailStop":"Disable automated email notices",
                  "dailyTimePeriod":"Daily time period",
                  "noticeAmount":"Notice amount (EUR)",
                  "noticeAmountUnder":"Notice amount under (EUR)",
                  "noticeAmountAbove":"Notice amount above (EUR)",
                  "agreedToReceiveNotices":"I agree to receive notices",
                  "agreedToGeneralTerms":"I agree with the General Terms and Conditions",
                  "agreedToStopTerms":"I agree to stop receiving notices",
                  "yes":"Yes",
                  "no":"No",
                  "orderDate":"Order date",
                  "orderType":"Order type",
                  "daily":"Daily",
                  "weekly":"Weekly",
                  "monthly":"Monthly",
                  "period":"Period",
                  "dailyPeriod":"Daily period",
                  weekDays:{
                    "monday":"Monday",
                    "tuesday":"Tuesday",
                    "wednesday":"Wednesday",
                    "thursday":"Thursday",
                    "friday":"Friday",
                    "saturday":"Saturday",
                    "sunday":"Sunday"
                  },
                  "newOrder":"New order",
                  "archive":"Archive",
                  "successMsg":"Order was successfully submitted."
                },
              "showNotificationFor":"I want to receive notifications:",
              "notificationSmsNumber":"SMS number for delivering notifications:",
              "notificationMailAddress":"Email address for delivering notifications:",
              "unsubscribeHeader":"Unsubscribing from mobile banking",
              "unsubscribeText":"Unsubscribing from Addiko Mobile bank shall enter into force on the first day of the following month. To re-subscribe to Addiko Mobile bank just log in to your Addiko Mobile application.",
              "unsubscribeButton":"Unsubscribe",
              "unsubscribeAlertHeader":"Are you sure you want to unsubscribe from using Addiko Mobile bank?"
            },
            orderSoftToken: {
                title: "Order soft token",
                infoTxt1: "You can place an order for a soft token, which can be used instead of a hard token. Soft token is an application on your mobile phone, which enables a one-time password generation for signing in to Addiko EBank and Addiko Mobile and can fully replace the hard token.",
                infoTxt2: "After the successful submission of your order you will receive two separate activation codes in your Addiko EBank mailbox and on your mobile phone to activate the soft token, which serves to generate one-time passwords. More information about the soft token can be found",
                linkTxt: "on our website.",
                emailLbl: "Email:",
                telephoneLbl: "Mobile telephone number:",
                okBtn: "Confirm",
                nextBtn: "Next",
                cancelBtn: "Cancel",
                successTxt: "Order submitted successfully!",
                changeEmail: "Change email",
                changeGsm: "Change phone",
                backBtn:"Back",
                nameAndSurmane: "Name and surname"
            },
            mobilePhoneSettings: {
              setMobilePhoneNumber: "Set mobile phone number",
              title: "Set mobile phone number for notifications",
              headerInfoText: 'Mobile phone number is used for notifications on selected events and confirmation of transactions. If you want to change your general mobile phone number in banking systems and mobile phone number used for MasterCard activites (OTP SMS, SMS notifications), you can make a request through function "Send message to the bank" under Messages.',
              mobilePhoneLabel: "Mobile phone number",
              confirmMobilePhone: "I AM CONFIRMING THAT MY MOBILE PHONE NUMBER IS VALID AND I AGREE TO RECEIVE ALL NOTIFICATIONS ON THIS MOBILE PHONE NUMBER. I ALSO WISH TO RECEIVE SAFETY CODES FOR CONFIRMATION OF TRANSACTIONS ON THIS PHONE NUMBER.",
              firstConfirmationTitle: "First confirmation of the existing mobile telephone number",
              firstConfirmationText: "If Addiko Bank d.d. holds your mobile telephone number, the latter has already been entered in the input field. After the confirmation of the number you will receive a confirmation code via a SMS message which you need to enter in the field for the confirmation code. In this way you will officially confirm the validity of your mobile phone number.",
              changingExistingNumberTitle: "Changing the existing number of your mobile phone",
              changingExistingNumberText: "If Addiko Bank d.d. holds your mobile phone number, the latter has already been entered in the field. If you would like to change the number of your mobile phone, delete the already entered one and enter the new one. After the confirmation of this number you will receive a SMS message to your OLD mobile phone number with the confirmation code which you need to enter in the field for the confirmation code. In this way you will officially confirm the validity of the NEW mobile phone number. If you no longer have access to your OLD phone number, you need to make arrangements to change it at one of our Addiko branches. After signing the relevant form we will take care of the official confirmation of your new mobile phone number.",
              newPhoneNumberTitle: "New mobile phone number",
              newPhoneNumberText: "If Addiko Bank d.d. does not hold your mobile phone number yet, you will need to visit one of our Addiko branches. After signing the relevant form we will take care of the official confirmation of your mobile phone number. After the official confirmation of your mobile phone number you will be able to receive notifications and codes for the confirmation of your transactions via SMS messages.",

              orderDate: "Order date",
              orderType: "Order type",
              orderTypeInfo: "Set mobile phone number for notifications",
              dataConfirmation: "Data confirmation",
              additionalPaymentConfirmationTitle: "Additional confirmation",
              additionalPaymentConfirmationText: "Additional confirmation is required for payments which are not saved under Templates (restriction does not apply for transfers between the holder and authorized accounts), and for changing mobile phone number.",
              SMSCode: "Enter the verification code you received via SMS message:",

              gsmPhoneError: "Entered mobile phone number is not in the correct format.",
              requiredField: "Required field.",
              SMSCodeRequired: "Confirmation code is required.",
              numberChangeSuccess: "Your mobile phone number was changed successfully."
            }
        };

        $translateProvider.translations('en', data);

    }
}());
